module.exports = __webpack_public_path__ + "media/img/ms-icon-310x310-86707633628c87f7256b14e7e05219bc.png";